import { gql } from '@apollo/client';
import { CORE_PAGE_INFO_FIELDS } from 'src/components/providers/apollo-provider-provider';

const WEBSITE_SOURCE_FIELDS_FRAGMENT = gql`
  fragment WebsiteSourceFields on AIAgentWebsiteSource {
    id
    title
    url
    status
    size
    createdAt
    lastSyncedAt
    mode
    maxPages
    crawlDepth
    sitemap
    includePaths
    excludePaths
    allowSubdomains
  }
`;

export const WEBSITE_SOURCES_LIST_QUERY = gql`
  ${CORE_PAGE_INFO_FIELDS}
  ${WEBSITE_SOURCE_FIELDS_FRAGMENT}
  query WebsiteSourcesList(
    $companyId: Int!
    $knowledgeBaseId: ID!
    $after: String
    $before: String
    $first: Int
    $last: Int
    $orderBy: AIAgentWebsiteSourceOrderByInput
  ) {
    aiAgents {
      listWebsiteSources(
        companyId: $companyId
        knowledgeBaseId: $knowledgeBaseId
        after: $after
        before: $before
        first: $first
        last: $last
        orderBy: $orderBy
      ) {
        totalCount
        pageInfo {
          ...PageInfoFragment
        }
        nodes {
          ...WebsiteSourceFields
          pages(first: 1) {
            totalCount
          }
        }
      }
    }
  }
`;

export const WEBSITE_SOURCE_DETAIL_QUERY = gql`
  ${WEBSITE_SOURCE_FIELDS_FRAGMENT}
  query WebsiteSourceDetail($input: AIAgentWebsiteSourceInput!, $after: String) {
    aiAgents {
      getWebsiteSource(input: $input) {
        ...WebsiteSourceFields
        pages(first: 50, after: $after) {
          totalCount
          pageInfo {
            hasNextPage
            endCursor
          }
          edges {
            cursor
            node {
              id
              url
              size
            }
          }
        }
      }
    }
  }
`;

export const CREATE_WEBSITE_SOURCE_MUTATION = gql`
  ${WEBSITE_SOURCE_FIELDS_FRAGMENT}
  mutation CreateWebsiteSource($input: CreateAIAgentWebsiteSourceInput!) {
    aiAgents {
      createWebsiteSource(input: $input) {
        ...WebsiteSourceFields
      }
    }
  }
`;

export const UPDATE_WEBSITE_SOURCE_MUTATION = gql`
  ${WEBSITE_SOURCE_FIELDS_FRAGMENT}
  mutation UpdateWebsiteSource($input: UpdateAIAgentWebsiteSourceInput!) {
    aiAgents {
      updateWebsiteSource(input: $input) {
        ...WebsiteSourceFields
      }
    }
  }
`;

export const DELETE_WEBSITE_SOURCE_MUTATION = gql`
  mutation DeleteWebsiteSource($input: AIAgentWebsiteSourceInput!) {
    aiAgents {
      deleteWebsiteSource(input: $input) {
        success
      }
    }
  }
`;
